// enums
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, /**
 * Builds info table rows from imageInfo
 *
 * @param {*} imageInfo - info json object representing image metadata
 * @param {*} temperatureUnit - "C" or "F" (default "C")
 * @param {*} frameIndex - frame index of an IS2
 * @returns
 */ "default", {
    enumerable: true,
    get: function() {
        return getInfoTable;
    }
});
const _enums = require("../../IRViewer/lib/enums");
const _temperatureUnitsEnum = /*#__PURE__*/ _interop_require_default(require("../../enums/temperatureUnitsEnum.js"));
const _datetime = require("../datetime.js");
const _temperature = require("../temperature.js");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function getInfoTable(imageInfo = {}, temperatureUnit = _temperatureUnitsEnum.default.CELSIUS, frameIndex = 0) {
    var _calibrationData_calRangesInfo;
    const { [_enums.ImageInfoKeys.THERMAL_IMAGE_INFO_DATA]: thermalImageData = [], [_enums.ImageInfoKeys.CAMERA_DATA]: cameraData = {}, [_enums.ImageInfoKeys.CALIBRATION_DATA]: calibrationData = {} } = imageInfo;
    var _thermalImageData_frameIndex;
    const { imageDateTime = {}, capturedBackgroundTempC = 0, capturedEmissivity = 1.0, capturedTransmissionFactor = 1.0 } = (_thermalImageData_frameIndex = thermalImageData[frameIndex]) !== null && _thermalImageData_frameIndex !== void 0 ? _thermalImageData_frameIndex : {};
    let { irSensorHeight = 0, irSensorWidth = 0, cameraSerialNumber = "", cameraSerialNumber32Chars = "", companyName = "", companyName32Chars = "" } = cameraData;
    // fallback
    cameraSerialNumber = cameraSerialNumber || cameraSerialNumber32Chars;
    companyName = companyName || companyName32Chars;
    const { calRangeMinTempC = -20, calRangeMaxTempC = 100 } = (calibrationData === null || calibrationData === void 0 ? void 0 : (_calibrationData_calRangesInfo = calibrationData.calRangesInfo) === null || _calibrationData_calRangesInfo === void 0 ? void 0 : _calibrationData_calRangesInfo[frameIndex]) || {};
    const handleDisplayTemperature = (tempCelsius = 0)=>{
        return (0, _temperature.getDisplayTemperature)(tempCelsius, temperatureUnit);
    };
    const getDisplayTemperatureRange = (min, max)=>{
        const minDisplay = handleDisplayTemperature(min);
        const maxDisplay = handleDisplayTemperature(max);
        return `${minDisplay} to ${maxDisplay}`;
    };
    return [
        {
            id: _enums.InfoTableKeys.DATE_TIME,
            label: "Date & Time",
            value: (0, _datetime.formatDateTime)(imageDateTime)
        },
        {
            id: _enums.InfoTableKeys.IR_SENSOR_SIZE,
            label: "IR Sensor Size",
            value: `${irSensorWidth} X ${irSensorHeight}`
        },
        {
            id: _enums.InfoTableKeys.CAPTURED_BACKGROUND_TEMP,
            label: "Background Temperature",
            value: handleDisplayTemperature(capturedBackgroundTempC)
        },
        {
            id: _enums.InfoTableKeys.CAPTURED_EMISSIVITY,
            label: "Emissivity",
            value: `${capturedEmissivity * 100}%`
        },
        {
            id: _enums.InfoTableKeys.CAPTURED_TRANSMISSION,
            label: "Transmission",
            value: `${capturedTransmissionFactor * 100}%`
        },
        {
            id: _enums.InfoTableKeys.CALIBRATION_RANGE,
            label: "Calibration Range",
            value: getDisplayTemperatureRange(calRangeMinTempC, calRangeMaxTempC)
        },
        {
            id: _enums.InfoTableKeys.CAMERA_SERIAL_NUMBER,
            label: "Camera Serial",
            value: cameraSerialNumber
        },
        {
            id: _enums.InfoTableKeys.CAMERA_MODEL,
            label: "Camera Model",
            value: cameraSerialNumber.split("-")[0]
        },
        {
            id: _enums.InfoTableKeys.COMPANY_NAME,
            label: "Camera Manufacturer",
            value: companyName
        },
        {
            id: _enums.InfoTableKeys.SEVERITY,
            label: "Severity",
            value: ""
        }
    ];
}
